import { useEffect, useState } from "react";
import InfoCards from "./Cards/InfoCards";
import AIPerformanceChart from "./Graph/LineGraph";
import RecentAlerts from "./Cards/RecentAlert";
import AlertDistribution from "./Graph/AlertDistribution";
import ZoneStatus from "./Cards/ZoneStatus";
import { CiCamera } from "react-icons/ci";
import { IoWarningOutline } from "react-icons/io5";
import { TbWaveSawTool } from "react-icons/tb";
import { LuShield } from "react-icons/lu";
import { Row, Col } from "reactstrap";
import { errorToast } from "../../../../_helper/helper";
import DashboardService from "../../../../api/dashboardService";
import FactoryService from "../../../../api/factoryService";
import { getCurrentWeekWithYear } from "../../../../utils/currentWeekWithYear";
import { Loader3 } from "../../../../CommonElements/Spinner/loader";
import ModelAnalyticsHeader from "../GlobalFilterSE/ModelAnalytics";
import WeekFilterProvider from "../GlobalFilterSE/WeakGlobal";

// Constants
const FILTER_STORAGE_KEY = 'liveAnalyticsFilters';

function LiveAnalyticsSE() {
    const [isMidScreen, setIsMidScreen] = useState(false);
    const [DashboardSummary, setDashboardSummary] = useState({})
    const [lineChart, setlineChart] = useState()
    const [recentAlert, setrecentAlert] = useState([])
    const [alertDistribution, setalertDistribution] = useState([])
    const [zoneWiseAlerts, setzoneWiseAlerts] = useState([])
    const [subAreas, setSubareas] = useState([]);
    const [callApi, setCallApi] = useState(false);
    const [userData, setuserData] = useState(JSON.parse(localStorage.getItem('userData')))
    const [cardsData, setcardsData] = useState([
        {
            title: "Active Zone",
            mainValue: "124/130",
            subtitle: "6 Zone",
            icon: <CiCamera />,
            iconBgColor: "#C7D3FE",
            iconColor: "#4F46E5"
        },
        {
            title: "Active Alerts",
            mainValue: "7",
            subtitle: "3 critical, 4 warnings",
            icon: <IoWarningOutline />,
            iconBgColor: "#C7D3FE",
            iconColor: "#4F46E5",
            subtitleColor: "#EF4444"
        },
        {
            title: "AI Models Active",
            mainValue: "1/5",
            subtitle: "All models operational",
            icon: <TbWaveSawTool />,
            iconBgColor: "#C7D3FE",
            iconColor: "#4F46E5"
        },
        {
            title: "Monitored Zones",
            mainValue: "18",
            subtitle: "3 high-risk zones",
            icon: <LuShield />,
            iconBgColor: "#E0E7FF",
            iconColor: "#6366F1"
        }
    ])
    const [loading, setloading] = useState(true)

    // Helper function to get current week
    const getCurrentWeek = () => {
        const now = new Date();
        const oneJan = new Date(now.getFullYear(), 0, 1);
        const dayOfWeek = oneJan.getDay();
        const firstMondayOffset = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
        const firstMonday = new Date(oneJan.setDate(oneJan.getDate() + firstMondayOffset));
        const daysSinceFirstMonday = Math.floor((now - firstMonday) / 86400000);
        const weekNumber = Math.ceil((daysSinceFirstMonday + 1) / 7);
        return `${now.getFullYear()}-W${weekNumber.toString().padStart(2, "0")}`;
    };

    // Initialize filters state
    const [filters, setFilters] = useState(() => {
        const savedFilters = localStorage.getItem(FILTER_STORAGE_KEY);
        return savedFilters ? JSON.parse(savedFilters) : {
            customEndDate: "",
            customStartDate: "",
            date: '',
            filter: "",
            module: "",
            month: "",
            multiShift: [],
            severity: "",
            shift: [],
            subarea: [],
            timeFilterSelection: "week",
            week: getCurrentWeek(),

        };
    });

    const handleResize = () => {
        const width = window.innerWidth;
        setIsMidScreen(width <= 1400 && width > 1199);
    };

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch factories for sub areas
    const fetchFactories = () => {
        FactoryService.getAllFactories()
            .then((res) => {
                setSubareas(res.data?.data[0]?.areas?.[0]);
            })
            .catch((e) => {
                console.error("Error fetching factories:", e);
            });
    };

    // Create payload based on filters
    const createPayload = () => {
        const basePayload = {
            factory_id: userData.factory.id,
            client_id: userData.client.id,
        };

        // Determine filters based on time selection
        let dateFilters = {};

        if (filters.timeFilterSelection === 'week') {
            dateFilters = {
                week: filters.week || getCurrentWeek(),
                date: "",
                month: "",
                starting: "",
                ending: ""
            };
        } else if (filters.timeFilterSelection === 'month') {
            dateFilters = {
                week: "",
                date: "",
                month: filters.month || "",
                starting: "",
                ending: ""
            };
        } else if (filters.timeFilterSelection === 'daily') {
            dateFilters = {
                week: "",
                date: filters.date || "",
                month: "",
                starting: "",
                ending: ""
            };
        } else if (filters.timeFilterSelection === 'custom') {
            dateFilters = {
                week: "",
                date: "",
                month: "",
                starting: filters.customStartDate || "",
                ending: filters.customEndDate || ""
            };
        } else {
            // Default to week
            dateFilters = {
                week: getCurrentWeek(),
                date: "",
                month: "",
                starting: "",
                ending: ""
            };
        }

        return {
            ...basePayload,
            filters: dateFilters,
            // Additional filters for alert-specific calls
            module_ids: filters.module ? [filters.module] : [],
            zone_ids: Array.isArray(filters.subarea) ? filters.subarea.map(id => parseInt(id)) : [],
            shift: Array.isArray(filters.shift) ? filters.shift : [],
            severity: filters.severity || "",
        };
    };

    const getDashboardSummary = async () => {
        try {
            const payload = createPayload();
            const res = await DashboardService.getDashboardSummary(payload)
            if (res) {
                setDashboardSummary(res?.data.data)
                const allData = res?.data.data
                const active_zone = allData.active_zones
                const ai_models_active = allData.ai_models_active
                const monitored_zones = allData.monitored_zones
                setcardsData(
                    [
                        {
                            title: "Active Zone",
                            mainValue: `${active_zone.active}/${active_zone.total}`,
                            subtitle: `${active_zone.total} Zones`,
                            icon: <CiCamera />,
                            iconBgColor: "#C7D3FE",
                            iconColor: "#4F46E5"
                        },
                        {
                            title: "Active Alerts",
                            mainValue: "0",
                            subtitle: "-",
                            icon: <IoWarningOutline />,
                            iconBgColor: "#C7D3FE",
                            iconColor: "#4F46E5",
                            subtitleColor: "#EF4444"
                        },
                        {
                            title: "AI Models Active",
                            mainValue: `1/5`,
                            subtitle: "All models operational",
                            icon: <TbWaveSawTool />,
                            iconBgColor: "#C7D3FE",
                            iconColor: "#4F46E5"
                        },
                        {
                            title: "Monitored Zones",
                            mainValue: `2`,
                            subtitle: "1 high-risk zones",
                            icon: <LuShield />,
                            iconBgColor: "#E0E7FF",
                            iconColor: "#6366F1"
                        }
                    ]
                )
            }
        } catch (error) {
            console.log(error)
            errorToast('Error while fetching dashboard summary')
        }
    }

    const getLineChartData = async () => {
        try {
            const payload = createPayload();
            const res = await DashboardService.getLineChartData(payload)
            if (res) {
                setlineChart(res.data.data)
            }
        } catch (error) {
            console.log(error)
            errorToast('Error while fetching Graph data')
        }
    }

    const getRecentAlerts = async () => {
        try {
            const payload = createPayload();
            const res = await DashboardService.getRecentAlerts(payload)
            console.log(res.data)
            if (res) {
                const alertsCount = res.data?.data?.alerts?.length || 0;
                setcardsData(prevCards =>
                    prevCards.map(card =>
                        card.title === "Active Alerts"
                            ? {
                                ...card,
                                mainValue: alertsCount,
                                subtitle: "-",
                                icon: <IoWarningOutline />,
                                iconBgColor: "#C7D3FE",
                                iconColor: "#4F46E5",
                                subtitleColor: "#EF4444"
                            }
                            : card
                    )
                );

                setrecentAlert(res.data)
            }
        } catch (error) {
            console.log(error)
            errorToast('Error while fetching recent alert')
        }
    }

    const getAlertsDistribution = async () => {
        try {
            const payload = createPayload();
            const res = await DashboardService.getAlertsDistribution(payload)
            console.log(res.data.data, "alertsss")
            if (res) {
                setalertDistribution(res.data.data)
            }
        } catch (error) {
            console.log(error)
            errorToast('Error while fetching Alert Distribution')
        }
    }

    const getAlertZoneWise = async () => {
        try {
            const payload = createPayload();
            const res = await DashboardService.getAlertZoneWise(payload)
            console.log(res.data.data)
            if (res) {
                setzoneWiseAlerts(res.data.data)
            }
        } catch (error) {
            console.log(error)
            errorToast('Error while fetching alert zone wise')
        }
    }

    // Load all data
    const loadAllData = () => {
        setloading(true)
        Promise.all([
            getDashboardSummary(),
            getLineChartData(),
            getRecentAlerts(),
            getAlertsDistribution(),
            getAlertZoneWise()
        ]).finally(() => {
            setloading(false);
        });
    };

    // Initial load
    useEffect(() => {
        fetchFactories();
    }, []);

    // Load data when filters change or component mounts
    useEffect(() => {
        loadAllData();
    }, [callApi]);

    // Filter handlers
    const handleAccept = (payload1) => {
        const processedFilters = {
            ...payload1,
            shift: payload1.shift || [],
            acknowledge: payload1.acknowledge === "Acknowledged" ? "true" : ""
        };

        localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(processedFilters));
        setFilters(processedFilters);
        setCallApi(!callApi);
    };

    const handleReset = async () => {
        const emptyFilters = {
            customEndDate: "",
            customStartDate: "",
            date: "",
            filter: "",
            module: "",
            month: "",
            multiShift: [],
            severity: "",
            shift: [],
            subarea: [],
            timeFilterSelection: "week",
            week: getCurrentWeek(),
            acknowledge: "",
        };

        localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(emptyFilters));
        setFilters(emptyFilters);
        setCallApi(!callApi);
    };
    console.log("alertDistributionchecking please", alertDistribution);
    // === NORMAL LAYOUT (default) ===
    const renderDefaultLayout = () => (
        <div className="pt-4">
            <WeekFilterProvider>
                <ModelAnalyticsHeader
                    heading={`Live Analytics`}
                    currentWeek={false}
                    shifts={false}
                    multiShift={false}
                    months={false}
                    modules={false}
                    severity={false}
                    timeFilterOption={true}
                    areas={false}
                    acknowledge={false}
                    showActions={true}
                    onAccept={handleAccept}
                    onReset={handleReset}
                    subAreas={subAreas}
                    setFilters={setFilters}
                    filters={filters}
                    FILTER_STORAGE_KEY={FILTER_STORAGE_KEY}
                />
                {
                    loading ? <div className="py-5">
                        <Loader3 />
                    </div> : <>
                        <Row className="g-4">
                            {cardsData.map((card, index) => (
                                <Col key={index} xl={3} lg={6} md={6} sm={6}>
                                    <InfoCards {...card} />
                                </Col>
                            ))}
                        </Row>
                        <Row className="mt-4">
                            <Col xl={8}>
                                <AIPerformanceChart lineChart={lineChart} />
                            </Col>
                            <Col xl={4}>
                                <RecentAlerts recentAlert={recentAlert} />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col xl={8}>
                                <AlertDistribution alertDistributions={alertDistribution} />
                            </Col>
                            <Col xl={4} md={12} sm={12}>
                                <ZoneStatus zoneWiseAlerts={zoneWiseAlerts} />
                            </Col>
                        </Row>
                    </>
                }
            </WeekFilterProvider>
        </div>
    );

    // === MID-SCREEN LAYOUT (1200–1400px) ===
    const renderMidScreenLayout = () => (
        <div className="pt-4">
            <WeekFilterProvider>
                <ModelAnalyticsHeader
                    heading={`Live Analytics`}
                    currentWeek={false}
                    shifts={false}
                    multiShift={false}
                    months={false}
                    modules={false}
                    severity={false}
                    timeFilterOption={true}
                    areas={false}
                    acknowledge={false}
                    showActions={true}
                    onAccept={handleAccept}
                    onReset={handleReset}
                    subAreas={subAreas}
                    setFilters={setFilters}
                    filters={filters}
                    FILTER_STORAGE_KEY={FILTER_STORAGE_KEY}
                />
                {
                    loading ? <div className="py-5">
                        <Loader3 />
                    </div> : <>
                        <Row className="g-4">
                            {cardsData.map((card, index) => (
                                <Col key={index} lg={6} md={6} sm={6}>
                                    <InfoCards {...card} />
                                </Col>
                            ))}
                        </Row>
                        <Row className="mt-4">
                            <Col md={12}>
                                <AIPerformanceChart lineChart={lineChart} />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col md={6}>
                                <RecentAlerts recentAlert={recentAlert} />
                            </Col>
                            <Col md={6}>
                                <ZoneStatus zoneWiseAlerts={zoneWiseAlerts} />
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col md={12}>
                                <AlertDistribution alertDistributions={alertDistribution} />
                            </Col>
                        </Row>
                    </>
                }
            </WeekFilterProvider>
        </div>
    );

    return isMidScreen ? renderMidScreenLayout() : renderDefaultLayout();
}

export default LiveAnalyticsSE;